import { ProjectBuilder } from "../components/Project/ProjectBuilder";
import WordifyMe from "./ProjectList/WordifyMe"
const Projectlist = [];


Projectlist.push(WordifyMe);

const Segro = new ProjectBuilder({
    name: "Segro",
    githubLink: "https://github.com/pmj9911/Segro",
    // https://github.com/pmj9911/Segro ,
    description: " An end to end solution for waste segregation, collection and disposal. Me and my team mate, Ms. Shloka Shah came up with this idea in Hack-N-Code 3.0. We completed the development of the entire system in Hack by the Beach, along with 2 other teammates. This project was accepted in the IEEE International Conference for Emerging Technology, June 2020. ",
    Technology: ["python-plain-wordmark", "javascript-plain colored"],
    projectDuration: "October 2019 - June 2020 ",
})
Projectlist.push(Segro);

const Rhea = new ProjectBuilder({
    name: "RHEA",
    githubLink: " https://github.com/pmj9911/RHEA",
    // https://github.com/pmj9911/RHEA 
    Technology: ["python-plain-wordmark", "typescript-plain colored"],//,"javascript-plain colored"], 
    description: "This project was aimed at improving the way in which people revised. It was based off a problem statement given to my team during the VIT Hackathon.",
    projectDuration: "September, 2019",
})
Projectlist.push(Rhea);

const Vote = new ProjectBuilder({
    name: "Voting Application",
    githubLink: " https://github.com/pmj9911/Vote-Application",
    // https://github.com/pmj9911/Vote-Application ,
    Technology: ["javascript-plain colored", "Solidity"],
    description: "This is a basic implementation of a voting system, using blockchain. It uses a local ethereum network, where accounts on the network are allowed to vote.",
    projectDuration: "June 2020 ",
})
Projectlist.push(Vote);

const SDASRP = new ProjectBuilder({
    name: "Student depression and Suicide rate prediction",
    githubLink: "https://github.com/pmj9911/Student-Depression-And-Suicide-Rate-Prediction",
    projectDuration: "December 2019 ",
    Technology: ["python-plain-wordmark"],//"Jupyter Notebook", 
    description: "This problem statement was given to my team in Data-Quezt. We had to conduct EDA on the dataset and with appropriate ML techniques, reach a conclusion for the given data. Detailed analysis can be found on the github repo.",
    // https://github.com/pmj9911/Student-Depression-And-Suicide-Rate-Prediction 
})
Projectlist.push(SDASRP);

const DLProject = new ProjectBuilder({
    name: "DL-Projects",
    githubLink: " https://github.com/pmj9911/DL-Projects",
    // https://github.com/pmj9911/DL-Projects ,
    Technology: ["python-plain-wordmark"],
    description:"A few Deep Learning projects, which were done after completing the deep learning specialization offered on Coursera.",
    projectDuration: "May 2020 ",
})
Projectlist.push(DLProject);

const FlutterAll = new ProjectBuilder({
    name: "flutter-all",
    githubLink: " https://github.com/pmj9911/flutter-all",
    //https://github.com/pmj9911/flutter-all ,
    Technology: ["dart"],
    projectDuration: "9 June 2020 ",
})
Projectlist.push(FlutterAll);

// const DjagoRest = new ProjectBuilder({
//     name : "Django-Rest-Example ",
//     githubLink :   "https://github.com/pmj9911/Django-Rest-Example",
//     //https://github.com/pmj9911/Django-Rest-Example ,
//     //Technology1 : "python-plain-wordmark",
//     projectDuration:  "6 June 2020 ",
//     })
// Projectlist.push(DjagoRest);

const HealthApp = new ProjectBuilder({
    name: "healthApp",
    githubLink: "https://github.com/pmj9911/healthApp",
    //https://github.com/pmj9911/healthApp ,
    Technology: ["dart"],
    projectDuration: "22 December 2019 ",
})
Projectlist.push(HealthApp);

const TSS = new ProjectBuilder({
    name: "Twitter-Sentiment-Analyser",
    githubLink: "https://github.com/pmj9911/Twitter-Sentiment-Analyser",
    // https://github.com/pmj9911/Twitter-Sentiment-Analyser ,
    Technology: ["python-plain-wordmark", "javascript-plain colored"],
    projectDuration: "13 December 2019 ",
})
Projectlist.push(TSS);

const PrimeVideoClone = new ProjectBuilder({
    name: "PrimeVideo_Clone",
    githubLink: " https://github.com/pmj9911/PrimeVideo_Clone",
    // https://github.com/pmj9911/PrimeVideo_Clone ,
    Technology: ["python-plain-wordmark", "javascript-plain colored"],
    projectDuration: "8 September 2019 ",
})
Projectlist.push(PrimeVideoClone);

const FlaskBlog = new ProjectBuilder({
    name: "Flask-Blog ",
    githubLink: "https://github.com/pmj9911/Flask-Blog",
    // https://github.com/pmj9911/Flask-Blog ,
    Technology: ["python-plain-wordmark"],
    projectDuration: "2 November 2019 ",
})
Projectlist.push(FlaskBlog);

const DjangoBlog = new ProjectBuilder({
    name: "Django-Blog ",
    githubLink: "https://github.com/pmj9911/Django-Blog",
    // https://github.com/pmj9911/Django-Blog ,
    Technology: ["python-plain-wordmark", "javascript-plain colored"],
    projectDuration: "8 July 2019 ",
})
Projectlist.push(DjangoBlog);

// const DAV = new ProjectBuilder({
//     name : "Data-analytics-and-visualisation All the code and data sets worked on during the training by suven consultants pvt ltd for Data analytics and visualisation using R ",
//     githubLink :   "https://github.com/pmj9911/Data-analytics-and-visualisation",
//     // https://github.com/pmj9911/Data-analytics-and-visualisation ,
//     //Technology1 : "R ",
//     projectDuration:  "23 June 2019 ",
//     })
// Projectlist.push(DAV);

// const LOC = new ProjectBuilder({
//     name : "LOC-Empower Project created for,  LOC- lines of code organised by ACM of  D. J. Sanghvi , A 24 hr hackathon. team members are:  ",
//     githubLink :   "https://github.com/pmj9911/LOC-Empower",
//     // https://github.com/pmj9911/LOC-Empower ,
//     //Technology1 : "typescript-plain colored",
//     //Technology2 :
//     //Technology3 : 
//     //Technology4 : "javascript-plain colored",
//     projectDuration:  "6 June 2020 ",
//     })
// Projectlist.push(LOC);

// const Codeshashtra = new ProjectBuilder({
//     name : "CODESHASHTRA-fintech Project created when participated in the Codeshashtra 5.0 hackathon organised by CSI of D J Sanghvi on 2nd and 3rd march 2019  ",
//     githubLink :   "https://github.com/pmj9911/CODESHASHTRA-fintech",
//     // https://github.com/pmj9911/CODESHASHTRA-fintech ,
//     //Technology1 : "typescript-plain colored",
//     //Technology2 :
//     //Technology3 : 
//     //Technology4 : "javascript-plain colored",
//     projectDuration:  "6 June 2020 ",
//     })
// Projectlist.push(Codeshashtra);

const Cricbuzz = new ProjectBuilder({
    name: "Cricbuzz  ",
    githubLink: "https://github.com/pmj9911/Cricbuzz",
    // https://github.com/pmj9911/Cricbuzz ,
    Technology: ["javascript-plain colored"],
    projectDuration: "6 June 2020 ",
})
Projectlist.push(Cricbuzz);

// const TravelWebsite = new ProjectBuilder({
//     name : "TravelWebsite  ",
//     githubLink :   "https://github.com/pmj9911/TravelWebsite",
//     // https://github.com/pmj9911/TravelWebsite ,
//     // //Technology1: javascript-plain colored: 55.8 %",
//     //Technology2 :
//     //Technology3 : 
//     //Technology4 : "PHP",
//     projectDuration:  "18 April 2019 ",
//     })
// Projectlist.push(TravelWebsite);

// const SEProject = new ProjectBuilder({
//     name : "SE_Project Project made as a part of OOP Course.  ",
//     githubLink :   "https://github.com/pmj9911/SE_Project",
//     // https://github.com/pmj9911/SE_Project ,
//     //Technology1 : "javascript-plain colored",
//     //Technology2 : "Java",
//     projectDuration:  "6 February 2019 ",
//     })
// Projectlist.push(SEProject);

// const Hangman = new ProjectBuilder({
//     name : "FE_Project A hangman game written in C language.  ",
//     githubLink :   "https://github.com/pmj9911/FE_Project",
//     //https://github.com/pmj9911/FE_Project ,
//     //Technology1 : "C",
//     projectDuration:  " 6 February: 2019",
//     })
// Projectlist.push(Hangman);

export default Projectlist;
